import { Flex, Typography } from "antd"

export const CheckoutsCreateStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        You don’t always need an API integration to accept cryptocurrency
        payments from customers. <br />
        With Checkouts, you can:
      </Typography.Text>

      <ul>
        <li>Create payment requests for a fixed or open amount.</li>
        <li>Personalize the payment page by adding your logo and an image.</li>
      </ul>

      <Typography.Text>
        This allows you to start accepting crypto payments quickly and easily.
      </Typography.Text>
    </Flex>
  )
}
